<template>
    <div>
      <div class="row">
  
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
      </div>
        <div class="float-md-right mb-3">
  
          <el-tooltip
              placement="top"
              :effect="themeMode.darkMode == true ? 'light' : 'dark'"
              :content="$t('print_detail')">
            <button
                type="button"
                @click.prevent="generateReport"
                class="btn btn-primary btn-sm">Print
            </button>
          </el-tooltip>
  
        </div>
      </div>
      <div class="row">
  
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="card card-with-shadow border-0 h-100">
            <app-overlay-loader v-if="preloader"/>
            <div class="card-header d-flex justify-content-between align-items-center p-primary bg-transparent">
              <a href="#"> <h5 class="card-title d-inline-block mb-0">{{$t('check-call')}}</h5>
              </a>
            </div>
            <div class="card-body">
              <form ref="form" :data-url="siteLogUrl" class="mb-0" :class="{'loading-opacity': preloader}">
                <div class="form-group row align-items-center">
                  <div>
                    <app-button :isDisabled="false" type="submit" :label="$t('record-check-call')" class-name="btn-info rounded-pill mr-2"
                                v-on:submit="submit(eventType)" />
                                
                    <app-button :isDisabled="false" type="submit" :label="$t('add-another-time')" class="btn-dark rounded-pill mr-2"
                          @submit="showDateTime()"/>
                  </div>
                </div>

                <div v-if="showCalendar" class="form-group row align-items-center">
                  <div class="col-md-12 mb-sm-0">
                    <label for="event_recorded_at">
                      {{ $t('event_recorded_at') }}
                    </label>
                  </div>
                  <div class="col-md-4">
                    <app-input
                      :required="true"
                      type="date"
                      v-model="inputs.event_recorded_at"
                      :placeholder="$t('select_valid_date')"/>
                  </div>
                  <div class="col-md-4">
                    <app-input
                      :required="true"
                      type="time"
                      v-model="inputs.time_picker"
                      :placeholder="$t('select_valid_time')"/>
                  </div>
                  
                  <div class="action-buttons">
                    <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit(eventType)">
                      Check In
                    </button>
                  </div>
                </div>

              </form>
            </div>
  
          </div>
        </div>

      </div>
  
    </div>
  </template>
  
  
  <script>

  import {TableHelpers} from "../../../../Demo/Tables/mixins/TableHelpers";
  import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
  import {SITE_LOGS, SITE_LOGS_DATA} from "../../../../../../Config/ApiUrl.js";
  import {axiosGet} from "../../../../../../Helpers/AxiosHelper.js";
  import {FormMixin} from "@/core/mixins/form/FormMixin";

  import GlobalHelperMixin from "@/app/Mixins/global/GlobalHelperMixin";
  import AppLibrary from "@/app/Helpers/AppLibrary";

  export default {
    name: 'SiteCheckCall',
    extends: CoreLibrary,
    mixins: [GlobalHelperMixin, FormMixin, AppLibrary, TableHelpers],
    props:{
      siteId: Number,
    },
    data() {
      return {
        showCalendar: false,
        preloader: false,
        checkOutForm: false,
        CheckForm: false,
        instructionShow: false,
        eventType: 4,
        siteLogUrl: SITE_LOGS + '/' + this.$attrs['props'].siteId,
        inputs: {}

      };
    },
    methods: {
      beforeSubmit() {
        this.preloader = true;
      },
      submit(event_type) {

        this.inputs.event_type = event_type;
        this.inputs.event_status = 2;
        this.inputs.severity = 1;
        this.save(this.inputs);
  
      },
      showDateTime() {
        this.showCalendar = true
      },
      afterSuccess(res) {
        this.$toastr.s(res.data.message);
      },
      afterFinalResponse() {
        this.preloader = false;
        this.inputs = {};
      },
      afterError(res) {
        this.$toastr.e(res.data.message);
      },

    },
    mounted() {
      this.$hub.$on('siteData', (data) => {
        this.siteData = data;
      })

      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  
    },
    computed: {
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
      themeMode() {
        return this.$store.state.theme;
      },
    },
  };
  </script>
  